import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {AllowedPageSizes} from '../../../../../const/constants';
const TransactionTransportTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    
    const gridKey = "8F2DE7A4-44B2-457F-A334-73637904B010";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
             
                <Scrolling mode="virtual" />
                <Column dataField="record" caption="Record#" dataType="string" />
                <Column dataField="identityId" caption="Customer" dataType="string" />
                <Column dataField="name" caption="Customer Name" dataType="string" />
                <Column dataField="transportationMode" caption="Transportation Mode" dataType="string" />
                <Column dataField="agent" caption="Agent" dataType="string" />
                <Column dataField="carrier" caption="Carrier" dataType="string" />
                <Column dataField="equipmentId" caption="Equipment" dataType="string" />
                <Column dataField="driver" caption="Driver" dataType="string" />
                <Column dataField="truckReference" caption="Reference#" dataType="string" />
                <Column dataField="transportCarrier" caption="Trans Carrier" dataType="string" visible={false} />
                <Column dataField="transportCarrierName" caption="Trans Carrier Name" dataType="string" visible={false} />
                <Column dataField="container" caption="Container" visible={false} />
                <Column dataField="equipmentInterchangeReport" caption="Equipment Interchange Report" visible={false} />
                <Column dataField="truckArrivalDateTime" caption="Truck Arrival Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="truckDepartDateTime" caption="Truck Depart Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="deliveryPickupDepartDateTime" caption="Delivery Pickup Depart Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="transportationYardLeaveDate" caption="Transportation Yard Leave Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="warehouseID" caption="Warehouse ID" visible={false} />
                <Column dataField="dockYardWarehouseName" caption="Dock Yard Warehouse Name" visible={false} />
                <Column dataField="putawaybyplandate" caption="Putaway By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="location" caption="Location" visible={false} />
                <Column dataField="creationDateTime" caption="Creation Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="creationUserId" caption="Creation User ID" visible={false} />
                <Column dataField="lastUpdateDateTime" caption="Last Update Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="lastUpdateUserId" caption="Last Update User ID" visible={false} />
                <Column dataField="department" caption="Department" visible={false} />
                <Column dataField="departmentDescription" caption="Department Description" visible={false} />
                <Column dataField="job" caption="Job" visible={false} />
                <Column dataField="jobDescription" caption="Job Description" visible={false} />
                <Column dataField="fund" caption="Fund" visible={false} />
                <Column dataField="fundDescription" caption="Fund Description" visible={false} />
                <Column dataField="dockYardWH" caption="Dock Yard WH" visible={false} />
                <Column dataField="dockYardWHName" caption="Dock Yard WH Name" visible={false} />
                <Column dataField="plannedReceivedShippedDateTime" caption="Planned Received Shipped Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingStartDate" caption="Staging Start Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="stagingEndDate" caption="Staging End Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="unloadPickByPlanDate" caption="Unload Pick By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="checkByPlanDate" caption="Check By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="putAwayByPlanDate" caption="Put Away By Plan Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="fmTruckReference" caption="FM Truck Reference" visible={false} />
                <Column dataField="fmDriverReference" caption="FM Driver Reference" visible={false} />
                <Column dataField="fmTrailerReference" caption="FM Trailer Reference" visible={false} />
                <Column dataField="deliveryPickupPlannedDateTime" caption="Delivery Pickup Planned Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="deliveryPickupArrivedDateTime" caption="Delivery Pickup Arrived Date" visible={false} dataType="date" format="MM/dd/yyyy" />
                <Column dataField="transportDriverID" caption="Transport Driver ID" visible={false} />
                <Column dataField="transportDriverName" caption="Transport Driver Name" visible={false} />
                <Column dataField="transportTrailerID" caption="Transport Trailer ID" visible={false} />
                <Column dataField="transportTruckID" caption="Transport Truck ID" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransactionTransportTab);